const accessRoute = {
  BI_METRIC: {
    path: "/admin/bi-metric",
  },
};
export default accessRoute;
